// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3879":"css/app.6675","6870":"css/admin-app.6675"}[chunkId] + ".css";
};